import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import api, { apiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";
import { fmtDateTime } from "./adminUtils";

export default function AdminUsers() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/users")
      .then((r) => setUsers(r.data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  const filtered = users.filter((u) =>
    !q || [u.name, u.email].some((f) => (f || "").toLowerCase().includes(q.toLowerCase())));

  return (
    <div data-testid="admin-users-page">
      <PageHeader
        title="Users"
        subtitle="Global directory of every user account on the platform."
        action={
          <Input
            placeholder="Search name or email…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="rounded-sm w-64"
            data-testid="admin-user-search"
          />
        }
      />

      <div className="bg-card border border-border rounded-sm overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead className="text-center">Platform Admin</TableHead>
              <TableHead className="text-center">Organizations</TableHead>
              <TableHead>Last Login</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">Loading…</TableCell></TableRow>}
            {!loading && filtered.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">No users</TableCell></TableRow>}
            {filtered.map((u) => (
              <TableRow
                key={u.id}
                className="cursor-pointer"
                onClick={() => navigate(`/admin/users/${u.id}`)}
                data-testid={`admin-user-row-${u.email}`}
              >
                <TableCell className="font-medium">{u.name || "—"}</TableCell>
                <TableCell className="font-mono text-xs">{u.email}</TableCell>
                <TableCell className="text-center">
                  {u.is_platform_admin
                    ? <Badge className="rounded-sm text-[10px] uppercase" data-testid={`admin-user-flag-${u.email}`}>Yes</Badge>
                    : <span className="text-muted-foreground text-xs">No</span>}
                </TableCell>
                <TableCell className="text-center tabular-nums">{u.organizations_count}</TableCell>
                <TableCell className="text-sm">{fmtDateTime(u.last_login)}</TableCell>
                <TableCell className="text-right text-muted-foreground"><CaretRight size={16} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
